import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, RoutesRecognized } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
import { DataService } from '@services/data/data.service';
import { RolesService } from '@services/roles/roles.service';
import { UiService } from '@services/ui/ui.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RoleUser implements CanActivate {
    private stateUrl: string;
    routeData: any;

    constructor(
        private dataService: DataService,
        private router: Router,
        private authService: AuthService,
        private uiService: UiService
    ) { }

    canActivate(next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        const appsUser = this.authService.getDecodedToken()?.application;

        this.routeData = next.data.application;

        const appUserRoute = appsUser?.find(app => app.applicationName?.toLowerCase() === this.routeData?.application?.toLowerCase());
        const indexAppUserRoute = appsUser?.findIndex(app => app.applicationName?.toLowerCase() === this.routeData?.toLowerCase());

        this.dataService.userAppSelected.next(appUserRoute?.roleUser);

        if (indexAppUserRoute !== -1) {
            return true;
        }

        this.uiService.showSnackbar('You do not have access to this application');
        this.router.navigate(['/choose-appli']);

        return false;

    }



}
